import { rgba } from 'polished';
import styled, { css, keyframes } from 'styled-components';
import { getShadow } from '../../../foundation/theme/shape.utils';
import { getRadius, getSpace } from '../../../foundation/theme/space.utils';
import { MODAL_SIZES_MAP } from './Modal.constants';
// styled-components.
// -----------------------------------------------------------------------------
export const ModalButtons = styled.div `
  align-items: center;
  display: flex;
  gap: 1rem;
  justify-content: flex-start;

  ${({ buttonsFullWidth }) => buttonsFullWidth &&
    css `
      justify-content: center;

      button {
        width: 100%;
      }
    `}
`;
export const ModalContent = styled.div `
  margin-top: ${getSpace('xl')};
`;
const fadeInOverlay = keyframes `
  from { opacity: 0; }
  to   { opacity: 1; }
`;
export const ModalOverlay = styled.div `
  align-items: center;
  animation-name: ${fadeInOverlay};
  animation-duration: 0.3s;
  animation-fill-mode: forwards;
  background: ${rgba('#353241', 0.8)};
  display: flex;
  height: 100vh;
  justify-content: center;
  left: 0;
  opacity: 1;
  position: fixed;
  top: 0;
  width: 100vw;
  z-index: 20;
`;
const fadeInModal = keyframes `
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;
export const ModalRoot = styled.div `
  ${({ size, theme }) => css `
    animation-name: ${fadeInModal};
    animation-duration: 0.3s;

    box-shadow: ${getShadow({ mode: 'light', theme, variant: 'xl' })};
    background: #fff;
    border-radius: ${getRadius('m')};
    max-height: 90vh;
    overflow: auto;
    padding: ${getSpace('2xl')};
    position: relative;

    width: ${MODAL_SIZES_MAP[size]}px;
    z-index: 99999;

    .btn__close {
      background-color: transparent;
      border: 0;
      cursor: pointer;
      padding: 0;
      position: absolute;
      top: ${getSpace('2xl')};
      right: ${getSpace('2xl')};
    }
  `}
`;
export const ModalTitle = styled.div `
  align-items: center;
  display: flex;
  justify-content: space-between;
`;
//# sourceMappingURL=Modal.styled.js.map